export default __webpack_public_path__ + "static/MALLOWS_FALLING-c3b4d1ab6b29dee027bcf534b44f3e0d.png";